import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import App from './components/app';
import reducers from './reducers';
import InitialState from './init_state';

console.log('store created');
ReactDOM.render(

  <Provider store={ createStore(reducers, InitialState) }>
    <App />
  </Provider>,
  document.querySelector('#main')
);

//一、Provider组件接受redux的store作为props，然后通过context往下传。
//
// 二、connect函数收到Provider传出的store，然后接受三个参数mapStateToProps，mapDispatchToProps和组件，
// 并将state和actionCreator以props传入组件，这时组件就可以调用actionCreator函数来触发reducer函数返回新的state，
// connect监听到state变化调用setState更新组件并将新的state传入组件。
//
// connect可以写的非常简洁，mapStateToProps，mapDispatchToProps只不过是传入的回调函数，connect函数在必要的时候会调用它们，
// 名字不是固定的，甚至可以不写名字。